/* @flow */
import React from 'react';
import WindowDialog from 'components/WindowDialog.jsx';
import PaymentView from 'rsvp/components/PaymentView.jsx';
import Button from 'components/Button.jsx';
import Image from 'components/Image.jsx';
import Text from 'components/Text.jsx';
import './styles/ActivityRSVPPreview.scss';

export default class ActivityRSVPPreview extends React.Component {

  static childContextTypes = {
    isPreview: React.PropTypes.bool,
  }

  getChildContext() {
    return {
      isPreview: true,
    };
  }

  renderBanner() {
    return (
      <div className="ActivityRSVPPreview-banner">
        <div className="ActivityRSVPPreview-banner-contentContainer">
          <Image
            className="ActivityRSVPPreview-banner-image"
            src={require('assets/images/payments/activity-celebration.svg')}
          />
          <div className="ActivityRSVPPreview-banner-content">
            <Text size="small" element="span">
              This is a web preview of your invitation!
            </Text>
            <br />
            <Text size="xsmall" element="span" color="thunder">
              Sms participants will receive a link to this invitation, and you can reply to RSVP.
            </Text>
          </div>
        </div>
        <Button
          className="ActivityRSVPPreview-banner-button"
          level="secondary"
          size="small"
          onClick={this.props.onRequestHide}
          eventElementName="ActivityRSVPPreview-banner-button">
          Close
        </Button>
      </div>
    );
  }

  render() {
    return (
      <WindowDialog className="ActivityRSVPPreview" onRequestHide={this.props.onRequestHide} hideCloseButton>
        {this.renderBanner()}
        <div className="ActivityRSVPPreview-background">
          <div className="ActivityRSVPPreview-content">
            <div className="ActivityRSVPPreview-hero" />
            <PaymentView {...this.props} />
          </div>
        </div>
      </WindowDialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/ActivityRSVPPreview.jsx